import React from "react";
import {
  StoryblokVisionBanner,
  StoryblokVisionValue,
} from "../../../interfaces/Storyblok/StoryblokVisionBanner.interface";
import Image from "../../atoms/Image/Image.atom";
import Crumb from "../../atoms/Crumb/Crumb.atom";

const VisionBanner: React.FC<StoryblokVisionBanner> = ({ crumb, title, values }) => {
  return (
    <section className="bg-Primary-50">
      <div className="container mx-auto py-16 md:py-20">
        <div className="flex flex-col items-center text-center">
          {crumb && <Crumb label={crumb} className="mb-6" />}

          {title && (
            <h2 className="max-w-3xl text-3xl font-extrabold leading-tight text-Body md:text-4xl">{title}</h2>
          )}
        </div>

        {!!values?.length && (
          <ul className="mt-12 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:mt-16 lg:grid-cols-4 lg:gap-8">
            {values.map((value: StoryblokVisionValue) => (
              <li key={value._uid} className="flex flex-col items-center text-center">
                <div className="mb-6 h-14 w-14 md:h-16 md:w-16">
                  <Image image={value.icon} objectFit="contain" isDecorative />
                </div>
                {value.title && (
                  <h3 className="mb-3 text-xl font-extrabold text-Primary-900 md:text-2xl">{value.title}</h3>
                )}
                {value.description && (
                  <p className="max-w-[16rem] text-base leading-relaxed text-Body">{value.description}</p>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
};

export default VisionBanner;
